import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

// Bulgarian Flag SVG
const BulgariaFlag: React.FC = () => (
  <svg viewBox="0 0 36 24" className="w-7 h-5 rounded border border-gray-300 shadow-sm">
    <rect x="0" y="0" width="36" height="8" fill="#ffffff"/>
    <rect x="0" y="8" width="36" height="8" fill="#00966E"/>
    <rect x="0" y="16" width="36" height="8" fill="#D62612"/>
  </svg>
);

// UK Flag SVG (Union Jack)
const UKFlag: React.FC = () => (
  <svg viewBox="0 0 36 24" className="w-7 h-5 rounded border border-gray-300 shadow-sm">
    <rect x="0" y="0" width="36" height="24" fill="#012169"/>
    <path d="M0,0 L36,24 M36,0 L0,24" stroke="#ffffff" strokeWidth="4"/>
    <path d="M0,0 L36,24 M36,0 L0,24" stroke="#C8102E" strokeWidth="2.5"/>
    <path d="M18,0 L18,24 M0,12 L36,12" stroke="#ffffff" strokeWidth="6"/>
    <path d="M18,0 L18,24 M0,12 L36,12" stroke="#C8102E" strokeWidth="4"/>
  </svg>
);

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const targetLang = language === 'bg' ? 'en' : 'bg';
  const Flag = targetLang === 'bg' ? BulgariaFlag : UKFlag;

  const handleSwitch = () => {
    setLanguage(targetLang);
  };

  return (
    <button
      onClick={handleSwitch}
      className="hover:opacity-80 transition-opacity duration-300 focus:outline-none"
      aria-label={`Switch to ${targetLang.toUpperCase()}`}
    >
      <Flag />
    </button>
  );
};

export default LanguageSwitcher;
